module.exports = __webpack_public_path__ + "static/media/apc.3b66a78f.png";